"use client";

import { styled } from "styled-components";

import { poppins_body_sm_medium } from "../../shared/font/poppins/body";

const STATUS_STYLES = {
  pending: "#11AC45",
  success: "#0198E9",
  error: "#E53E06",
};

export const Badge = styled.span<{
  $status: "pending" | "success" | "error";
}>`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-left: auto;
  height: var(--Size-Btn-Xs, 2rem);
  color: ${({ $status }) => STATUS_STYLES[$status]};
  ${poppins_body_sm_medium}
  white-space: nowrap;
`;

export const SpinningIcon = styled.span`
  display: inline-flex;
  align-items: center;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  svg {
    animation: spin 2s linear infinite;
  }
`;
